import { EnumTypeValue } from "@/shared/types";

export const PrognoseStatusOptions = {
    Initieel: "Initieel",
    Aangepast: "Aangepast",
    TenMinsteTot: "Ten minste tot",
    Definitief: "Definitief",
} as const;

export type PrognoseStatus = EnumTypeValue<typeof PrognoseStatusOptions>;
